export const DELIVERY_PERIODS = [
    {
        day: 'Monday',
        value: 1
    },
    {
        day: 'Tuesday',
        value: 2
    },
    {
        day: 'Wednesday',
        value: 3
    },
    {
        day: 'Thursday',
        value: 4
    },
    {
        day: 'Friday',
        value: 5
    },
    {
        day: 'Saturday',
        value: 6
    },
    {
        day: 'Sunday',
        value: 7
    }
];

export const LOGGING_LABELS = {
    "platform": [{
        id:1,
        label:"Console"
    }],
    "mode": [{
        id:1,
        label:"Restaurant"
    },{
        id:2,
        label:"Supplier"
    }],
    "action": [{
        id:1,
        label:"Created"
    }, {
        id:2,
        label:"Approved"       
    }, {
        id:3,
        label:"Rejected"       
    },{
        id:4,
        label:"Updated"
    },{
        id:5,
        label:"Imported"
    }],
}

export const DEFAULT_DEP_NAME = "採購部";

export const EASYSOFT = "EASYSOFT";
export const ECOUNT = "ECOUNT";
export const MULTIABLE = "MULTIABLE";
export const INVOICE = "INVOICE";

export const RESTAURANT = "restuarant";
export const SUPPLIER = "supplier";
export const INTERNAL = "internal";
export const EXTERNAL = "external";

export const PO = "PURCHASE_ORDER";
export const GR = "GOODS_RECEIPT";

export const PRODUCTS  = "products";
export const UI  = "ui";
export const UNITS = "units";
export const BUSINESSES = "businesses";
export const BRANCHES = "branches";
export const DEPARTMENTS = "departments";
export const STORAGES = "storages";
export const SUPPLIERS = "suppliers";

export const MAX_UPLOAD_FILE_SIZE = 5242880;

export const ZH_HK = "zh-hk";
export const EN = "en";

export const I18N_LOCALES = [{
    "locale":"zh-hk",
    "label":"繁體中文"
},{
    "locale":"en",
    "label":"English"    
}];

export const GOODS_NAME = "GoodsName";
export const GOODS_NAME_ALIAS = "GoodsNameAlias";
export const GOODS_CODE = "GoodsCode";

export const UAT = "uat";